module.exports = __webpack_public_path__ + "static/media/arrow-next-outline.418560d0.svg";